import { useQuery } from '@tanstack/react-query';
import { useOrgStore } from '@/stores/org-store';
import { getPrimaryAgent } from '@/services/agents/primary';
import type { Agent } from '@/types/agent-types';

export const primaryAgentQueryKey = (orgId?: string) =>
  ['primary-agent', orgId] as const;

export const usePrimaryAgent = () => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<Agent | null, Error>({
    queryKey: primaryAgentQueryKey(orgId),
    queryFn: () => getPrimaryAgent(orgId!),
    enabled: !!orgId,
    staleTime: 30_000,
    retry: 1,
  });
};
